'use client';

import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { trackClientInfo } from '../../../../../../services/tracking/trackClientInfo';

type SubscriptionCloseButtonProps = {
  storyId?: string;
  episodeNumber?: string;
  state?: string;
  isAnonymous: boolean;
};

export const SubscriptionCloseButton: React.FC<SubscriptionCloseButtonProps> = ({
  storyId,
  episodeNumber,
  state,
  isAnonymous,
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    trackClientInfo('paywall-close_button-clicked', {
      storyId,
      episodeNumber,
      state,
    });

    if (state === 'subscription_failure') {
      window.location.href = '/';
      return;
    }

    if (isAnonymous && (storyId || episodeNumber)) {
      const redirectUrl = window.location.pathname + window.location.search;
      window.location.href = `/login?redirect=${encodeURIComponent(redirectUrl)}`;
      return;
    }

    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <button
      onClick={handleClose}
      className="absolute top-4 right-4 p-2 hover:bg-neutral-800 rounded-full transition-colors z-10"
      aria-label={String(t('common:close', 'Close'))}
    >
      <X className="w-6 h-6 text-white" />
    </button>
  );
};
